<template>
  <div class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
    <div class="glass-strong rounded-xl p-6 w-full max-w-lg mx-4">
      <h3 class="text-xl font-bold text-white mb-4">Check In Equipment</h3>
      <form @submit.prevent="submit">
        <div class="space-y-4">
          <div>
            <label class="block text-sm text-slate-300 mb-1">Outcome</label>
            <input
              v-model="outcome"
              class="w-full px-3 py-2 bg-slate-800/70 border border-slate-700 rounded-lg text-white"
            />
          </div>
          <div>
            <label class="block text-sm text-slate-300 mb-1">Condition In</label>
            <input
              v-model="conditionIn"
              class="w-full px-3 py-2 bg-slate-800/70 border border-slate-700 rounded-lg text-white"
            />
          </div>
        </div>
        <p v-if="error" class="text-red-400 text-sm mt-2">{{ error }}</p>
        <div class="flex space-x-3 mt-6">
          <button
            type="button"
            @click="$emit('close')"
            class="flex-1 px-4 py-2 bg-slate-800/70 border border-slate-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-[--ring]"
          >
            Cancel
          </button>
          <button type="submit" class="flex-1 px-4 py-2 rounded-lg btn-primary">Check In</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { closeCheckout } from '@/lib/appApi'

const props = defineProps<{ checkoutId: number }>()
const emit = defineEmits(['close', 'saved'])

const outcome = ref('')
const conditionIn = ref('')
const error = ref('')

async function submit() {
  try {
    error.value = ''
    await closeCheckout({
      checkoutId: props.checkoutId,
      outcome: outcome.value,
      conditionIn: conditionIn.value,
    })
    emit('saved')
    emit('close')
  } catch (e: any) {
    error.value = e.message || 'Failed to check in'
  }
}
</script>
